import { useSearchParams } from "react-router-dom";
import PageShell from "@/components/PageShell";
import CarpoolSection from "@/components/home/CarpoolSection";

export default function CovoituragePage() {
  const [params] = useSearchParams();
  const eventId = params.get("event") || null;
  return (
    <PageShell>
      <CarpoolSection eventFilter={eventId} />
    </PageShell>
  );
}
